import type React from "react";
import type { EmailMatch } from "../../../../hooks/useMatchingRestApi";
import { MatchingResultItem } from "./MatchingResultItem";

export interface MatchingResultProps {
  results: EmailMatch[];
  totalAnalyzed?: number;
  candidateInfo?: string;
}

export const MatchingResult: React.FC<MatchingResultProps> = ({
  results,
  totalAnalyzed,
  candidateInfo,
}) => {
  if (results.length === 0) {
    return (
      <div className="bg-base-100 rounded-xl p-6 shadow-xl text-center">
        <p className="text-base-content/80">
          マッチする案件が見つかりませんでした。
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold">マッチング結果</h2>
        {totalAnalyzed && (
          <div className="text-sm text-base-content/60">
            {totalAnalyzed}件の案件から{results.length}件をマッチング
          </div>
        )}
      </div>
      <div className="space-y-6">
        {results.map((result: EmailMatch) => (
          <MatchingResultItem key={result.emailId} result={result} />
        ))}
      </div>
    </div>
  );
};

export default MatchingResult;
